import { createModel } from '@/store/tools';

const model = {
    namespace: 'taxdeclaration',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getTableSource': T('getTableSource'),
        },
        actions: {
            'getTableSource': A('getTableSource'),
        },
        sagas: {
            'getTableSource': S('getTableSource', '/ad/list'),
        },
        reducers: {
            'tableSource': R('getTableSource', { dataList: [], pageNum: 1, pageSize: 25, resultTotal: 0 }),
        }
    })
};
export default createModel(model);